import React from 'react'
import { motion } from "framer-motion"
import {
  containerAnimation,
  childAnimation,
  imageAnimation,
  fastAnimation,
  fastContainerAnimation,
  lineAnimation,
  hoverAnimation
} from '../data/animations'

const House = () => {
  return (
    <div className='overflow-hidden'>
      <motion.div
        className='h-[calc(100vh-6rem)] w-full  relative overflow-hidden'
        initial="initial"
        animate="animate"
        viewport={{ once: false, amount: 0 }}
        variants={containerAnimation}
      >
        <motion.img
          src='/images/projects/house/1.jpg'
          className='h-full w-full object-cover'
          variants={imageAnimation}
        />

        <div className='absolute bottom-0 left-0 h-1/3 w-full bg-gradient-to-t from-black to-transparent '></div>
        <div className='absolute top-0 left-0 h-full w-full  flex flex-col justify-between z-20 px-[16.6%] md:px-0'>
          <div className='flex md:justify-center md:items-center pt-20'>
            <motion.div
              className='relative w-2/3 md:w-64'
              variants={childAnimation}
            >
              <motion.img
                src='/images/projects/house/logo-house-white-u.svg'
                className='w-full'
                variants={childAnimation}
              />
              <motion.img
                src='/images/projects/house/logo-house-white-text.svg'
                className='w-full absolute top-0'
                variants={childAnimation}
              />
            </motion.div>
          </div>

          <div className=' flex flex-col md:flex-row md:justify-between md:items-end w-full   md:px-20 pb-10'>
            <div className='relative w-2/3 md:w-48 opacity-0 hidden md:block'>
              <img src='/images/projects/house/logo-guvence-ulus.svg' className='w-full' />
              <img src='/images/projects/house/logo-guvence-ulus-text.svg' className='w-full absolute top-0' />
            </div>
            <motion.h6
              className='text-white text-28 font-adobe tracking-[0.28rem] pb-6 md:pb-3'
              variants={childAnimation}
            >
              Şehrin tam yerinde, yaşamın merkezinde
            </motion.h6>
            <motion.div
              className='relative w-2/3 md:w-48'
              variants={childAnimation}
            >
              <img src='/images/projects/house/logo-guvence-ulus.svg' className='w-full' />
              <img src='/images/projects/house/logo-guvence-ulus-text.svg' className='w-full absolute top-0' />
            </motion.div>
          </div>
        </div>
      </motion.div>

      <motion.div
        className='min-h-screen h-screen md:h-[calc(100vh-8rem)] w-full  relative overflow-hidden'
        initial="initial"
        whileInView="animate"
        viewport={{ once: false, amount: 0 }}
        variants={containerAnimation}
      >
        <motion.img
          src='/images/projects/house/9.jpg'
          className='h-full w-full object-cover'
          variants={imageAnimation}
        />

        <div className='absolute top-0 left-0 h-full w-full  flex flex-col justify-center z-20 px-[16.6%] md:px-0'>
          <div className='flex flex-col md:justify-center md:items-center pt-20 space-y-10'>
            <motion.div
              className='relative w-2/3 md:w-64'
              variants={childAnimation}
            >
              <motion.img src='/images/projects/house/logo-b-u.svg' className='w-full' variants={childAnimation} />
              <motion.img src='/images/projects/house/logo-b-text.svg' className='w-full absolute top-0' variants={childAnimation} />
            </motion.div>

            <motion.p
              className='w-full md:w-3/4 text-24 font-medium leading-tight text-start text-[#404040]'
              variants={childAnimation}
            >
              hoUse, şehrin gelişen bölgelerinden birinde konumlanmaktadır. Çevresinde özel sağlık hastanesi, belediye hizmet
              binaları, park alanları ve alışveriş imkânları yer alırken; ana ulaşım akslarına ve günlük ihtiyaç noktalarına yakınlığı ile
              öne çıkar. Modern yaşamı kolaylaştıran sosyal olanaklara birkaç dakika mesafede bulunan proje, hem merkezi hem de
              huzurlu bir yaşamın kapılarını açmaktadır.
            </motion.p>

            <motion.div className='relative w-2/3 md:w-48' variants={childAnimation}>
              <img src='/images/projects/house/logo-guvence-ulus.svg' className='w-full' />
              <img src='/images/projects/house/logo-guvence-ulus-b-text.svg' className='w-full absolute top-0' />
            </motion.div>
          </div>
        </div>
      </motion.div>

      <motion.div
        className='h-[calc(100vh)] w-full  relative overflow-hidden'
        initial="initial"
        whileInView="animate"
        viewport={{ once: false, amount: 0 }}
        variants={containerAnimation}
      >
        <motion.img
          src='/images/projects/house/2.jpg'
          className='h-full w-full object-cover'
          variants={imageAnimation}
        />

        <div className='absolute bottom-0 left-0 h-1/3 w-full bg-gradient-to-t from-black to-transparent '></div>
        <div className='absolute top-0 left-0 h-full w-full  flex flex-col justify-end z-20 px-[16.6%] md:px-0'>
          <div className=' flex flex-col md:flex-row  md:items-end w-full   md:px-5 pb-10 md:pb-8  md:!pr-20'>
            <motion.div
              className='relative w-2/3 md:w-56 flex-none  pb-6'
              variants={childAnimation}
            >
              <motion.img src='/images/projects/house/logo-w-text.svg' className='w-full' variants={childAnimation} />
              <motion.img src='/images/projects/house/logo-w-u.svg' className='w-full absolute top-0' variants={childAnimation} />
              <motion.img src='/images/projects/house/logo-w-line.svg' className='w-full absolute top-0 overflow-hidden' variants={lineAnimation} />
            </motion.div>
            <div
              className='text-white font-adobe  leading-tight md:pl-28 pb-8'
            >
              <motion.h2 className='font-medium text-28 tracking-[0.28rem]' variants={childAnimation}>SAĞLAM ZEMIN, GÜVENLI YAŞAM</motion.h2>
              <motion.p variants={childAnimation}>Denizli'nin en değerli lokasyonlarından birinde yükselen hoUse, sağlam zemin üzerine inşa edilen güvenli bir yaşam sunuyor. </motion.p>
            </div>
          </div>
        </div>
      </motion.div>

      <motion.div
        className='h-[calc(100vh)] w-full  relative overflow-hidden'
        initial="initial"
        whileInView="animate"
        viewport={{ once: false, amount: 0 }}
        variants={containerAnimation}
      >
        <motion.img
          src='/images/projects/house/3.jpg'
          className='h-full w-full object-cover'
          variants={imageAnimation}
        />

        <div className='absolute bottom-0 left-0 h-1/3 w-full bg-gradient-to-t from-black to-transparent '></div>
        <div className='absolute top-0 left-0 h-full w-full  flex flex-col justify-end z-20 px-[16.6%] md:px-0'>
          <div className=' flex flex-col md:flex-row  md:items-end w-full   md:px-5 pb-10 md:pb-8  md:!pr-20'>
            <motion.div
              className='relative w-2/3 md:w-56 flex-none  pb-6'
              variants={childAnimation}
            >
              <motion.img src='/images/projects/house/logo-w-text.svg' className='w-full' variants={childAnimation} />
              <motion.img src='/images/projects/house/logo-w-u.svg' className='w-full absolute top-0' variants={childAnimation} />
              <motion.img src='/images/projects/house/logo-w-line.svg' className='w-full absolute top-0 overflow-hidden' variants={lineAnimation} />
            </motion.div>
            <div
              className='text-white font-adobe  leading-tight md:pl-28 pb-8'
            >
              <motion.h2 className='font-medium text-28 tracking-[0.28rem]' variants={childAnimation}>SOSYAL ALANLARLA ZENGINLEŞEN HAYAT</motion.h2>
              <motion.p variants={childAnimation}>Çocuk oyun parklarından dinlenme alanlarına, güvenlikten peyzaja… hoUse, sadece bir ev değil, komple bir yaşam alanı sunuyor.</motion.p>
            </div>
          </div>
        </div>
      </motion.div>

      <motion.div
        className='h-[calc(100vh)] w-full  relative overflow-hidden'
        initial="initial"
        whileInView="animate"
        viewport={{ once: false, amount: 0 }}
        variants={containerAnimation}
      >
        <motion.img
          src='/images/projects/house/4.jpg'
          className='h-full w-full object-cover'
          variants={imageAnimation}
        />

        <div className='absolute bottom-0 left-0 h-1/3 w-full bg-gradient-to-t from-black to-transparent '></div>
        <div className='absolute top-0 left-0 h-full w-full  flex flex-col justify-end z-20 px-[16.6%] md:px-0'>
          <div className=' flex flex-col md:flex-row  md:items-end w-full   md:px-5 pb-10 md:pb-8  md:!pr-20'>
            <motion.div
              className='relative w-2/3 md:w-56 flex-none  pb-6'
              variants={childAnimation}
            >
              <motion.img src='/images/projects/house/logo-w-text.svg' className='w-full' variants={childAnimation} />
              <motion.img src='/images/projects/house/logo-w-u.svg' className='w-full absolute top-0' variants={childAnimation} />
              <motion.img src='/images/projects/house/logo-w-line.svg' className='w-full absolute top-0 overflow-hidden' variants={lineAnimation} />
            </motion.div>
            <div
              className='text-white font-adobe  leading-tight md:pl-28 pb-8'
            >
              <motion.h2 className='font-medium text-28 tracking-[0.28rem]' variants={childAnimation}>SAĞLAM ZEMIN, GÜVENLI YAŞAM</motion.h2>
              <motion.p variants={childAnimation}>Denizli'nin en değerli lokasyonlarından birinde yükselen hoUse, sağlam zemin üzerine inşa edilen güvenli bir yaşam sunuyor. </motion.p>
            </div>
          </div>
        </div>
      </motion.div>

      <motion.div
        className='h-[calc(100vh)] w-full  relative overflow-hidden'
        initial="initial"
        whileInView="animate"
        viewport={{ once: false, amount: 0 }}
        variants={containerAnimation}
      >
        <motion.img
          src='/images/projects/house/5.jpg'
          className='h-full w-full object-cover'
          variants={imageAnimation}
        />

        <div className='absolute bottom-0 left-0 h-1/3 w-full bg-gradient-to-t from-black to-transparent '></div>
        <div className='absolute top-0 left-0 h-full w-full  flex flex-col justify-end z-20 px-[16.6%] md:px-0'>
          <div className=' flex flex-col md:flex-row  md:items-end w-full   md:px-5 pb-10 md:pb-8  md:!pr-20'>
            <motion.div
              className='relative w-2/3 md:w-56 flex-none  pb-6'
              variants={childAnimation}
            >
              <motion.img src='/images/projects/house/logo-w-text.svg' className='w-full' variants={childAnimation} />
              <motion.img src='/images/projects/house/logo-w-u.svg' className='w-full absolute top-0' variants={childAnimation} />
              <motion.img src='/images/projects/house/logo-w-line.svg' className='w-full absolute top-0 overflow-hidden' variants={lineAnimation} />
            </motion.div>
            <div
              className='text-white font-adobe  leading-tight md:pl-28 pb-8'
            >
              <motion.h2 className='font-medium text-28 tracking-[0.28rem]' variants={childAnimation}>NE KALABALIK, NE ISSIZ TAM YERINDE BIR KONUM</motion.h2>
              <motion.p variants={childAnimation}>Şehrin merkezine yakın ama gürültüsünden uzak bir noktada, dengeyi yakalayan modern bir yaşam alanı. hoUse, yaşam kalitesini lokasyonla birleştiriyor. </motion.p>
            </div>
          </div>
        </div>
      </motion.div>

      <motion.div
        className='h-[calc(100vh)] w-full  relative overflow-hidden'
        initial="initial"
        whileInView="animate"
        viewport={{ once: false, amount: 0 }}
        variants={containerAnimation}
      >
        <motion.img
          src='/images/projects/house/6.jpg'
          className='h-full w-full object-cover'
          variants={imageAnimation}
        />

        <div className='absolute bottom-0 left-0 h-1/3 w-full bg-gradient-to-t from-black to-transparent '></div>
        <div className='absolute top-0 left-0 h-full w-full  flex flex-col justify-end z-20 px-[16.6%] md:px-0'>
          <div className=' flex flex-col md:flex-row  md:items-end w-full   md:px-5 pb-10 md:pb-8  md:!pr-20'>
            <motion.div
              className='relative w-2/3 md:w-56 flex-none  pb-6'
              variants={childAnimation}
            >
              <motion.img src='/images/projects/house/logo-w-text.svg' className='w-full' variants={childAnimation} />
              <motion.img src='/images/projects/house/logo-w-u.svg' className='w-full absolute top-0' variants={childAnimation} />
              <motion.img src='/images/projects/house/logo-w-line.svg' className='w-full absolute top-0 overflow-hidden' variants={lineAnimation} />
            </motion.div>
            <div
              className='text-white font-adobe  leading-tight md:pl-28 pb-8'
            >
              <motion.h2 className='font-medium text-28 tracking-[0.28rem]' variants={childAnimation}>GÜVENILIR GELECEK, ULUS İNŞAAT İMZASIYLA </motion.h2>
              <motion.p variants={childAnimation}>Denizli'nin en güçlü inşaat firmalarından Ulus inşaat'ın yeni projesi hoUse, aileniz ve geleceğiniz için en doğru yatırım.</motion.p>
            </div>
          </div>
        </div>
      </motion.div>

      <motion.div
        className='h-[calc(100vh)] w-full  relative overflow-hidden'
        initial="initial"
        whileInView="animate"
        viewport={{ once: false, amount: 0 }}
        variants={containerAnimation}
      >
        <motion.img
          src='/images/projects/house/7.jpg'
          className='h-full w-full object-cover'
          variants={imageAnimation}
        />

        <div className='absolute bottom-0 left-0 h-1/3 w-full bg-gradient-to-t from-black to-transparent '></div>
        <div className='absolute top-0 left-0 h-full w-full  flex flex-col justify-end z-20 px-[16.6%] md:px-0'>
          <div className=' flex flex-col md:flex-row  md:items-end w-full   md:px-5 pb-10 md:pb-8  md:!pr-20'>
            <motion.div
              className='relative w-2/3 md:w-56 flex-none  pb-6'
              variants={childAnimation}
            >
              <motion.img src='/images/projects/house/logo-w-text.svg' className='w-full' variants={childAnimation} />
              <motion.img src='/images/projects/house/logo-w-u.svg' className='w-full absolute top-0' variants={childAnimation} />
              <motion.img src='/images/projects/house/logo-w-line.svg' className='w-full absolute top-0 overflow-hidden' variants={lineAnimation} />
            </motion.div>
            <div
              className='text-white font-adobe  leading-tight md:pl-28 pb-8'
            >
              <motion.h2 className='font-medium text-28 tracking-[0.28rem]' variants={childAnimation}>MODERN KONFOR, SADE ZARAFET</motion.h2>
              <motion.p variants={childAnimation}>Minimalist tasarımı, fonksiyonel yaşam alanları ve kaliteli malzemeleriyle hoUse, konforu zarafetle buluşturuyor.</motion.p>
            </div>
          </div>
        </div>
      </motion.div>

      <motion.div
        className='h-[calc(100vh)] w-full  relative overflow-hidden'
        initial="initial"
        whileInView="animate"
        viewport={{ once: false, amount: 0 }}
        variants={fastContainerAnimation}
      >
        <motion.img
          src='/images/projects/house/8.jpg'
          className='h-full w-full object-cover'
          variants={imageAnimation}
        />

        <motion.img
          src='/images/projects/house/8-1.svg'
          className='absolute top-0 left-0 h-full w-full object-cover'
          variants={fastAnimation}
        />
        <motion.img
          src='/images/projects/house/8-2.svg'
          className='absolute top-0 left-0 h-full w-full object-cover'
          variants={fastAnimation}
        />
        <motion.img
          src='/images/projects/house/8-3.svg'
          className='absolute top-0 left-0 h-full w-full object-cover'
          variants={fastAnimation}
        />
        <motion.img
          src='/images/projects/house/8-4.svg'
          className='absolute top-0 left-0 h-full w-full object-cover'
          variants={fastAnimation}
        />
        <motion.img
          src='/images/projects/house/8-5.svg'
          className='absolute top-0 left-0 h-full w-full object-cover'
          variants={fastAnimation}
        />
        <motion.img
          src='/images/projects/house/8-6.svg'
          className='absolute top-0 left-0 h-full w-full object-cover'
          variants={fastAnimation}
        />

        <div className='absolute bottom-0 left-0 h-1/3 w-full bg-gradient-to-t from-black to-transparent '></div>
        <div className='absolute top-0 left-0 h-full w-full  flex flex-col justify-end z-20 px-[16.6%] md:px-0'>
          <div className=' flex flex-col md:flex-row  md:items-end w-full   md:px-5 pb-10 md:pb-8  md:!pr-20'>
            <motion.div
              className='relative w-2/3 md:w-56 flex-none  pb-6'
              variants={childAnimation}
            >
              <motion.img src='/images/projects/house/logo-w-text.svg' className='w-full' variants={childAnimation} />
              <motion.img src='/images/projects/house/logo-w-u.svg' className='w-full absolute top-0' variants={childAnimation} />
              <motion.img src='/images/projects/house/logo-w-line.svg' className='w-full absolute top-0 overflow-hidden' variants={lineAnimation} />
            </motion.div>
            <div
              className='text-white font-adobe  leading-tight md:pl-28 pb-8'
            >
              <motion.h2 className='font-medium text-28 tracking-[0.28rem]' variants={childAnimation}>LOKASYON</motion.h2>
              <motion.p variants={childAnimation}>ULAŞIMIN, SAĞLIĞIN VE SOSYAL ALANLARIN ORTASINDA</motion.p>
            </div>
          </div>
        </div>
      </motion.div>

      <motion.div
        className='h-[calc(100vh)] w-full  relative overflow-hidden bg-black'
        initial="initial"
        whileInView="animate"
        viewport={{ once: false, amount: 0 }}
        variants={containerAnimation}
      >
        <div className='absolute bottom-0 left-0 h-1/3 w-full bg-gradient-to-t from-black to-transparent '></div>
        <div className='absolute top-0 left-0 h-full w-full  flex flex-col justify-center z-20 px-[16.6%] md:px-0'>
          <div className=' flex md:flex-row flex-col w-full  justify-center items-center md:space-x-16 space-y-16 md:space-y-0'>
            <motion.div
              className='relative w-2/3 md:w-64 md:pb-20'
              variants={childAnimation}
            >
              <motion.img src='/images/projects/house/logo-house-white-u.svg' className='w-full' variants={childAnimation} />
              <motion.img src='/images/projects/house/logo-house-white-text.svg' className='w-full absolute top-0' variants={childAnimation} />
            </motion.div>

            <motion.div
              className=' flex flex-col items-center justify-center space-y-10'
            >
              <motion.div
                className='relative flex-none font-adobe border text-center border-white leading-tight py-2 px-10 text-white'
                variants={childAnimation}
              >
                <motion.p className='text-24 md:text-35 font-medium' variants={childAnimation}>Detaylı Bilgi İçin</motion.p>
                <motion.a href='tel:05309740440' target='_blank' className='block text-28 md:text-45 font-bold' variants={childAnimation} whileHover={hoverAnimation.whileHover}>0 530 974 04 40</motion.a>
                <motion.a href='https://www.ulus.co' target='_blank' className='block text-24 md:text-35 leading-none mb-0.5' variants={childAnimation} whileHover={hoverAnimation.whileHover}>www.ulus.co</motion.a>

              </motion.div>
              <motion.a


                className='block mt-4'
                variants={childAnimation}
                whileHover={{ scale: 1.1 }}
              >
                <motion.div className="inline-flex space-x-2 py-2 px-6 rounded-3xl  bg-ulusOrange  cursor-pointer">
                  <h6 className="text-14 md:text-21 text-white font-bold">KATALOG İÇİN TIKLAYINIZ</h6>
                  <img src="/images/icons/kesfet-right.svg" className="w-8" />
                </motion.div>
              </motion.a>
            </motion.div>

            <motion.div
              className='relative w-2/3 md:w-56 md:pb-20'
              variants={childAnimation}
            >
              <motion.img src='/images/projects/house/logo-guvence-ulus.svg' className='w-full' variants={childAnimation} />
              <motion.img src='/images/projects/house/logo-guvence-ulus-text.svg' className='w-full absolute top-0' variants={childAnimation} />
            </motion.div>
          </div>
        </div>
      </motion.div>
    </div>
  )
}

export default House